import { BENEFIT_PACK_INFO, BENEFIT_PACK_INFO_SUCCESS, BENEFIT_PACK_INFO_ERROR, BENEFIT_PACK_INFO_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const BenefitPackInfo = (state = initialState, action) => {
  switch (action.type) {
    case BENEFIT_PACK_INFO:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case BENEFIT_PACK_INFO_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case BENEFIT_PACK_INFO_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case BENEFIT_PACK_INFO_EMPTY:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default BenefitPackInfo;
